import React from "react";
import { Container, Spinner, Tab, Tabs } from "react-bootstrap";
import { dateFormatter } from "../../../../_helpers/dateFormatter";
function CandidateKanbanSearch({
  candidateKanbanSearch,
  onViewApplicantProgressClick,
  candidateKanbanSearchLoading,
}) {
  return (
    <div>
      {candidateKanbanSearchLoading ? (
        <div className="d-flex justify-content-center align-items-center w-100">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Tabs defaultActiveKey="Candidates" className="mt-3">
          <Tab eventKey="Candidates" title="Search Candidates">
            <h2 className="mb-4">
              Showing {candidateKanbanSearch?.length} Result
            </h2>

            {Array.isArray(candidateKanbanSearch) &&
            candidateKanbanSearch.length ? (
              <>
                <div className="mentor-list row">
                  {candidateKanbanSearch &&
                    Array.isArray(candidateKanbanSearch) &&
                    candidateKanbanSearch.map((item) => (
                      <div className="col-md-6 col-lg-4 mb-lg-0 mb-4">
                        <div className="mentor-box bg-white border-radius-10 border p-3 ">
                          <div className="d-flex align-items-start ">
                            <div className="img-box">
                              {item?.candidate_details?.user_meta_info
                                ?.profile_image ? (
                                <>
                                  <img
                                    src={item?.candidate_details?.user_meta_info?.profile_image?.slice(
                                      0,
                                      item?.candidate_details?.user_meta_info?.profile_image?.indexOf(
                                        "?"
                                      )
                                    )}
                                    alt="user img"
                                    className="user-img border-radius-10 mr-3"
                                  />
                                </>
                              ) : (
                                <>
                                  <img
                                    src="/assets/images/user.png"
                                    alt="user img"
                                    className="user-img border-radius-10 mr-3"
                                  />
                                </>
                              )}
                            </div>
                            <div className="info mr-2">
                              <h3 className="mb-0 text-primary font-weight-medium text-capitalize">
                                {
                                  item?.candidate_profile_details?.user_details
                                    ?.full_name
                                }
                              </h3>
                              <p className="text-grey-4">
                                {item?.candidate_profile_details?.headline}
                              </p>
                            </div>
                            <span className="label-voilet d-inline-block rounded-lg px-1 ml-auto fs-smallest">
                              {item?.interview_stage}
                            </span>
                          </div>

                          <div className="content flex-grow-1 mt-3">
                            {Array.isArray(
                              item?.candidate_profile_details?.skills
                            ) &&
                            item?.candidate_profile_details?.skills?.length ? (
                              <>
                                <div className="d-flex flex-wrap align-items-center mt-2">
                                  {Array.isArray(
                                    item?.candidate_profile_details &&
                                      item?.candidate_profile_details?.skills
                                  ) &&
                                    item?.candidate_profile_details?.skills?.map(
                                      (skill) => (
                                        <div
                                          className={
                                            " bg-light-blue rounded-lg text-nowrap text-primary py-1 px-3 mr-1 text-capitalize mb-2 fs-smallest"
                                          }
                                        >
                                          {skill?.skill_name}
                                        </div>
                                      )
                                    )}
                                </div>
                              </>
                            ) : null}

                            <div className="border-top pt-3 mt-4 d-flex justify-content-between align-items-center">
                              <p className="text-grey-4 fs-smallest mb-0">
                                {dateFormatter(item?.updated)}
                              </p>
                              <button
                                className="btn text-primary font-weight-medium  p-0"
                                onClick={() => {
                                  onViewApplicantProgressClick(item?.id);
                                }}
                              >
                                View 
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </>
            ) : (
              <h2 className="text-danger text-center">No Candidate Found!</h2>
            )}
          </Tab>
        </Tabs>
      )}
    </div>
  );
}

export default CandidateKanbanSearch;
